import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
  color: ${({ theme }) => theme.colors.secondary};
`;
